module.exports = __webpack_public_path__ + "img/emotibot_logo.c18e704.38a58730.png";